import router from '@/router'
import store from '@/store'
import { getToken, setToken } from '@/utils/auth'
import { getUrlCode, getUrlParams, isMobile } from '@/utils/utils'
import { getFeiShuCodeLogin, getFeiShuToken } from '@/api/user'
import { getUserInfo } from '@/api/login'

const whiteList = ['/login']
function getQueryString(url) {
  if (url.indexOf('?') > -1) {
    url = url.split('?')[1]
  }
  let urlParams = []
  if (url.indexOf('&') > -1) {
    urlParams = url.split('&')
  }
  const obj = {}
  urlParams.forEach(item => {
    const strArray = item.split('=')
    obj[strArray[0]] = strArray[1]
  })
  return obj
}
export const getPa = () => {
  let pa = ''
  if (location.href.indexOf('?') > -1) {
    pa = location.href.split('?')[1]
    if (pa.indexOf('%3D') > -1) {
      pa = decodeURIComponent(`?${pa}`)
    } else {
      pa = `?${pa}`
    }
  }
  return encodeURIComponent(pa)
}
const gotoLogin = () => {
  // window.location.href = `https://open.feishu.cn/open-apis/authen/v1/index?app_id=${process.env.VUE_APP_FEISHU_APP_ID}&redirect_uri=${process.env.VUE_APP_FEISHU_REDIRECT_URI}&state=${encodeURIComponent(`processInstanceId=${getUrlParams('processInstanceId')}&taskId=${getUrlParams('taskId')}`)}`

  window.location.href = `https://open.feishu.cn/open-apis/authen/v1/index?app_id=${process.env.VUE_APP_FEISHU_APP_ID}&redirect_uri=${process.env.VUE_APP_FEISHU_REDIRECT_URI}&state=${encodeURIComponent(location.href)}`
}

const getUserInfoFunc = (next) => {
  getUserInfo().then(async(res) => {
    localStorage.setItem('accout', res.data.account)
    localStorage.setItem('userInfo', JSON.stringify(res.data))
    const urlParams = getQueryString(location.href)
    const state = urlParams.state
    if (state) {
      location.href = decodeURIComponent(state)
    }
  })
}
const handleLogin = (next) => {
  const code = getUrlCode().code // 截取code
  if (code == null || code === '') {
    gotoLogin()
  } else {
    // this.$loading.show()
    getFeiShuCodeLogin({
      clientId: process.env.VUE_APP_CLIENTID,
      ssoCode: code,
      loginType: 'FEI_SHU'
    })
      .then((res) => {
        // 获取用户授权码
        const params = {
          clientId: process.env.VUE_APP_CLIENTID, // 权限系统分配的clientId
          clientSecret: process.env.VUE_APP_CLIENTSECRET, // 权限系统提供的clientSecret
          ssoCode: res.data
        }
        getFeiShuToken(params)
          .then(async(res) => {
            localStorage.setItem('accessToken', res.data.accessToken)
            setToken(res.data.accessToken)
            getUserInfoFunc(next)
          })
          .catch(() => {
            gotoLogin()
          })
      })
      .catch((err) => {
        gotoLogin()
      })
      .finally(() => {})
  }
}

router.beforeEach(async(to, from, next) => {
  // if(!isMobile()) {
  //   gotoPc()
  // }else {
  if (whiteList.includes(to.path)) {
    return next()
  }
  const token = getToken()
  if (token) {
    store.dispatch('user/getInfo')
    next()
    // if (to.path === '/detail') {
    //   next()
    // } else {
    //   next('/detail')
    // }
    // next('/detail')
  } else {
    handleLogin(next)
  }
  // }
})
